import styled from 'styled-components'

const Content = styled.div<{ flushContent?: boolean }>`
  ${props => !props.flushContent && `padding: ${props.theme.spacing.base};`};
  position: relative;
`

export default Content
